import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "../../config/api";
import { toast } from "react-toastify";


// Async thunk for add feedback
export const addFeedback = createAsyncThunk(
  "add/feedback",
  async (userData, { rejectWithValue }) => {
    try {
      const response = await api.post("manager/feedbacks/create/", userData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const feedbackSlice = createSlice({
  name: "feedback",
  initialState: {
    data: null,
    status: "idle",
    error: null,
  },

  extraReducers: (builder) => {
    builder
    
      .addCase(addFeedback.pending, (state) => {
        state.status = "loading";
      })
      .addCase(addFeedback.fulfilled, (state, action) => {
        state.status = "add_feedback_succeeded";
        toast.success(action.payload?.message);
      })
      .addCase(addFeedback.rejected, (state, action) => {
        state.status = "failed";
        toast.error(action.payload?.message);
      });
  },
});

export default feedbackSlice.reducer;
